import pushToRetailRocket from './retailRocket';
import pushToGTM from './GTM';
import pushToYM from './YM';
import pushToOTM from './OTM';
import pushToGTM444 from './widgets/threeFours/GTM';
// eslint-disable-next-line
import * as types from './eventTypes';
export { default as pushToDashamail } from './dashamail';

const RR = 'rr';
const GTM = 'gtm';
const YM = 'ym';
const OTM = 'otm';

export * from './eventTypes';
export { positionGTMEnum } from './constants';

/**
 * Common entry point for analytics and event tracking
 * delegates event to all the systems listed in getEventHandlers for current eventTypes
 */
export default function pushEvent(type, data) {
  let eventProcessed = false;
  [GTM, YM, OTM].forEach((handler) => {
    switch (handler) {
      case GTM:
        eventProcessed = pushToGTM(type, data) || eventProcessed;
        eventProcessed = pushToGTM444(type, data) || eventProcessed;
        break;
      case YM:
        eventProcessed = pushToYM(type, data) || eventProcessed;
        break;
      case OTM:
        eventProcessed = pushToOTM(type, data) || eventProcessed;
        break;
      case RR:
        eventProcessed = pushToRetailRocket(type, data) || eventProcessed;
        break;
      default:
      // do nothing
    }
  });

  if (eventProcessed === false) {
    /**
     * throw Error without breaking the main thread
     */
    setTimeout(() => {
      throw new Error(`Pushed event was not processed by any handlers '${type}'`);
    }, 0);
  }
}

export const createPushStackedEvent = (eventType, baseUrl = '') => {
  let dataStack = [];
  let timer;

  return (data) => {
    dataStack.push(data);

    clearTimeout(timer);

    timer = setTimeout(() => {
      const eventData = {
        items: dataStack,
      };
      if (baseUrl) eventData.url = baseUrl;

      pushEvent(eventType, eventData);
      dataStack = [];
    }, 1000);
  };
};
